// Definição para o modal de busca de Empresas

export const configBuscaEmpresa = {
  label: 'Empresa',
  placeholder: 'ID ou Nome...',
  titulo: 'Buscar Empresa',
  endpointApi: 'Empresas',
  idField: 'idEmpresa',
  displayField: 'idEmpresa',
  descField: 'nomeEmpresa',

  camposFiltro: [
    { label: 'Nome da Empresa', model: 'nomeEmpresa', tipo: 'text' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idEmpresa', width: '15%' },
    { header: 'Nome da Empresa', dataField: 'nomeEmpresa', width: '85%' }
  ]
}
